export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/spellodrome-full-bdde90623d1f9d86f73dea21cc6eaa2d.svg";